import React, { FC, useState, useEffect } from "react"
import { useIntl } from "react-intl"
import { PageTitle } from "../../../smallnation/layout/core"
import { TablesWidget10 } from "../../../smallnation/partials/widgets"


import { ErrorMessage } from "@hookform/error-message";
import { set, useForm } from "react-hook-form";
import moment from "moment";
import services from "../../modules/services/services";
//import $, { parseJSON } from 'jquery';
import $ from 'jquery';
//import { useNavigate } from 'react-router-dom';
//import { CKEditor } from '@ckeditor/ckeditor5-react';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { useLocation, useHistory } from "react-router-dom";
import { Link } from 'react-router-dom';
import SunEditor, { buttonList } from "suneditor-react";
import 'suneditor/dist/css/suneditor.min.css';
import { Breadcrumb } from "react-bootstrap";
import AsyncSelect from "react-select/async";
import makeAnimated from "react-select/animated";
import Modal from 'react-modal';

const RepostJob: FC = ({ hrefIn }: any) => {
  const intl = useIntl();
  let history = useHistory();
  const [locationCounty, setLocationCounty] = useState([]);
  const [jobTypes, setJobType] = useState<any[]>([]);
  const [educations, setEducation] = useState([]);
  const [categories, setCategory] = useState([]);
  const [summary, setSummary] = useState<any>('');
  const [experience, setExperience] = useState<any>('');
  const [salary, setSalary] = useState<any>('');
  const [jobInfo, setJobInfo] = useState<any>([]);
  const [jobDetails, setJobDetails] = useState<any>([]);
  const [companyInfo, setCompanyInfo] = useState<any>([]);
  const [displayJobTitle, setDisplayJobTitle] = useState([]);
  const red = "red";
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedcompanyname, setselectedcompanyname] = useState([]);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const job_id = queryParams.get('job_id');
  const expjob = queryParams.get('exp');

  const [countyDisplayName, setCountyDisplayName] = useState('');
  const [countListAr, setCountListAr] = useState([]);

  //set default query terms
  const [socquery, setQuerysoc] = useState("");

  if (expjob == null) {
    var expstat = 0;
  }
  else {
    var expstat = 1;
  }

  var tabId: any = queryParams.get('tab');
  var companyId = queryParams.get('companyIdget');

  if (tabId == null) {

  } else {
    if (tabId == 5) {
      var menuname = "Current Jobs";
    }
    else if (tabId == 6) {
      var menuname = "Pending Jobs";
    }
    else if (tabId == 7) {
      var menuname = "Filled Jobs";
    }
    else if (tabId == 8) {
      var menuname = "Expired Jobs";
    }
    else {
      var menuname = 'Jobs List';
    }
  }
  const items = [
    { href: "/companyDetails?companyId=" + companyId + "&tab=1", name: "Company Details" },
    { href: "/companyDetails?companyId=" + companyId + "&tab=" + tabId, name: menuname },
    { name: "Edit Job" },
  ];

  const mydate = new Date();
  try {


    // const today = mydate.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();[]
  } catch (ex) {

  }

  let jobTitleGlobal = '';

  //get animated components wrapper
  const animatedComponentssoc = makeAnimated();

  // fetch filteres search results for dropdown
  // const loadOptions = () => {
  //   return fetch(`https://wagesurvey.hometownopportunity.com/api/jobSugList?title=${socquery}`)
  //     .then((res) => res.json());
  // };

  const loadOptions = () => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json', // Set the content type based on your API requirements
      },
      body: JSON.stringify({ title: socquery }), // Convert data to JSON format
    };
   
    return fetch('https://wagesurvey.hometownopportunity.com/api/jobSugList', requestOptions)
      .then((res) => res.json());
  };


  let subtitle;
  const [collab, setCollabs] = useState('');
  const [socCode, setSocCode] = useState('');
  const [socCodeTitle, setSocCodeTitle] = useState('');
  const [jobCodeTitle, setJobCode] = useState('');
  const [wageList, setWageListObj] = useState('');
  const [jobCodeTitleInput, setJobCodeTitleInput] = useState('');


  const [dolWageLevel1, setDolWageLevel1] = useState('');
  const [dolWageLevel2, setDolWageLevel2] = useState('');
  const [dolWageLevel3, setDolWageLevel3] = useState('');
  const [dolWageLevel4, setDolWageLevel4] = useState('');

  const [dolWageHourlyLevel1, setDolWageHourlyLevel1] = useState('');
  const [dolWageHourlyLevel2, setDolWageHourlyLevel2] = useState('');
  const [dolWageHourlyLevel3, setDolWageHourlyLevel3] = useState('');
  const [dolWageHourlyLevel4, setDolWageHourlyLevel4] = useState('');

  const [surveyWageLevel1, setsurveyWageLevel1] = useState('');
  const [surveyWageLevel2, setsurveyWageLevel2] = useState('');
  const [surveyWageLevel3, setsurveyWageLevel3] = useState('');
  const [surveyWageLevel4, setsurveyWageLevel4] = useState('');

  const [surveyWageHourlyLevel1, setsurveyWageHourlyLevel1] = useState('');
  const [surveyWageHourlyLevel2, setsurveyWageHourlyLevel2] = useState('');
  const [surveyWageHourlyLevel3, setsurveyWageHourlyLevel3] = useState('');
  const [surveyWageHourlyLevel4, setsurveyWageHourlyLevel4] = useState('');
  const handleChange = (selectedOption) => {
    //alert(JSON.stringify(selectedOption));
    var title = selectedOption.title;
    jobTitleGlobal = selectedOption.title;
    setJobCode(title);
    setSocCodeTitle(title);
    setSocCode(selectedOption.socCode);

    setTimeout(function () { getWageInfoCall(); }, 2000);


  }

  // const jobtypeName = queryParams.get('name');

  const {
    register,
    formState: { errors },
    handleSubmit
  } = useForm({
    criteriaMode: "all", mode: "onBlur"
  });

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: '100%',
      maxWidth: '600px',
      marginRight: '-50%',
      transform: 'translate(-30%, -38%)',

    },
  };

  function handleChangeSummaryDesc(content) {
    setSummary(content);
  }

  function handleChangeExperienceDesc(content) {
    setExperience(content);
  }

  function handleChangeSalaryDesc(content) {
    setSalary(content);
  }

  function handleImageUploadBefore(files: any, info: object, uploadHandler: Function) {
    var reader1 = new FileReader();
    reader1.readAsDataURL(files[0]);
    reader1.onload = function () {
      var rdt1: any = reader1.result;
      var base64result_banner = rdt1.split(',')[1];
      var bname = files[0].name;
      var bextn = bname.split(".").pop();
      var bannerActName = bname.split(".")[0];
      var fileext_banner = bextn;

      const requestObject = {
        //"imageName": files[0].name,
        "imageName": bannerActName,
        "imageExtension": fileext_banner,
        "imageByteString": base64result_banner
      };
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          //'Authorization': "Bearer "+accessTokenIn 
          //'Authorization': accessTokenIn 
        },
        body: JSON.stringify(requestObject)
      };

      services.fileUploadS3URL(requestOptions).then((res) => {
        const response = {
          // The response must have a "result" array.
          "result": [
            {
              "url": res.url,
              "temp": files[0],
              "name": bannerActName,
              "size": files[0].size
            },
          ]
        }
        uploadHandler(response);

      });
    };

  }

  function validateCheck() {

    const checked = $('input[name="category_list"]:checked').length;
    //alert(checked);
    if (checked >= 3) {
      $('input[name="category_list"]').not(':checked').prop('disabled', true);
    } else {
      $('input[name="category_list"]').prop('disabled', false);
    }

    if ($('#job_type').val() == '') {
      return false;
    }
    else if ($('#job_title').val() == '') {
      return false;
    }
    else {
      return true;
    }


  }
  const submitValue = () => {
    var industriesArray = [];
    var website_regex = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
    //var website_regex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
    $.each($("input[name='category_list']:checked"), function () {
      industriesArray.push($(this).val());
    });


    var isCheck = true;


    var validateEditorTxt = 1;
    if ($('#approval_status').val() == '') {
      $("#statusValidMsg").show();
      $(window).scrollTop($('#statusValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#statusValidMsg").hide();
    }

    if ($('#job_title').val() == '') {
      $("#jobtitleValidMsg").show();
      $(window).scrollTop($('#jobtitleValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#jobtitleValidMsg").hide();
    }

    /*if (jobCodeTitle == "") {
      $('#jobcodeValidMsg').show();
      $(window).scrollTop($('#jobcodeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $('#jobcodeValidMsg').hide();
    }
 
    if (socCode == "") {
      $("#soccodeValidMsg").show();
      $(window).scrollTop($('#soccodeValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#soccodeValidMsg").hide();
    } */

    if ($('#job_location').val() == '') {
      $("#joblocationValidMsg").show();
      $(window).scrollTop($('#joblocationValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#joblocationValidMsg").hide();
    }

    if ($('#job_type').val() == '') {
      $("#jobtypeValidMsg").show();
      $(window).scrollTop($('#jobtypeValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#jobtypeValidMsg").hide();
    }
    if ($('#education').val() == '') {
      $("#educationValidMsg").show();
      $(window).scrollTop($('#educationValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#educationValidMsg").hide();
    }

    if ($('#career_level').val() == '') {
      $("#careerLevelValidMsg").show();
      $(window).scrollTop($('#careerLevelValidMsg').position().top);
      validateEditorTxt = 0;
    }
    else {
      $("#careerLevelValidMsg").hide();
    }
    var howtoapply = $('#how_to_apply').val();
    /* if(howtoapply == ''){
       $("#applyValidMsg").show();
       $(window).scrollTop($('#applyValidMsg').position().top);
       validateEditorTxt = 0;
     }
     else{
       $("#applyValidMsg").hide();
     } */
    /*
            if(howtoapply != "" && website_regex.test(howtoapply)==false){
              $("#howtoapplyValidregex").show();  
                $(window).scrollTop($('#howtoapplyValidregex').position().top);
              validateEditorTxt = 0;     
            }else{
              $("#howtoapplyValidregex").hide();  
            } */

    var portallink: any = $('#portal_link').val();
    var portalvalid = website_regex.test(portallink);
    if (portallink != '') {
      console.log(portalvalid);
      if (portalvalid == true) {
        console.log('true val');
        $("#portalLinkValidregex").hide();
      }
      else {
        console.log('false val');
        $("#portalLinkValidregex").show();
        $(window).scrollTop($('#portalLinkValidregex').position().top);
        validateEditorTxt = 0;
      }
    }
    else {
      $("#portalLinkValidregex").hide();
    }

    if (industriesArray.length == 0) {
      $("#categoryValidMsg").show();
      validateEditorTxt = 0;
    }
    else {
      $("#categoryValidMsg").hide();
    }

    if (summary == "") {
      $("#summaryValidMsg").show();
      $(window).scrollTop($('#summaryValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#summaryValidMsg").hide();
    }

    if (experience == "") {
      $("#experienceValidMsg").show();
      $(window).scrollTop($('#experienceValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#experienceValidMsg").hide();
    }

    if (salary == "") {
      $("#salaryValidMsg").show();
      $(window).scrollTop($('#salaryValidMsg').position().top);
      validateEditorTxt = 0;
    } else {
      $("#salaryValidMsg").hide();
    }

    if (validateEditorTxt == 0) {
      return false;
    }
    /* {
         
      "jobposted_date": $('#posted_date').val(),
      "job_locCountry" : $('#job_location').val(),
  } */
    const requestObject =
    {
      "siteId": "2",
      "companyId": selectedcompanyname,
      "countyId": $('#job_location').val(),
      "jobTypeId": $('#job_type').val(),
      "educationId": $('#education').val(),
      "title": $('#job_title').val(),
      "summary": summary,
      "experiance": experience,
      "career": $('#career_level').val(),
      "apply": $('#how_to_apply').val(),
      "jobApplyUrl": $('#portal_link').val(),
      "retail": "nosuccess",
      "reference": $('#reference_code').val(),
      "salary": salary,
      "status": $("#approval_status").val(),
      "jobCategoryRelId": industriesArray
    }
    console.log(requestObject);
    //return false;
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.adminCreateJob(requestOptions).then((res) => {
      if (res.code == '200') {
        $("#repostjobsuccessMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#repostjobsuccessMessage").slideUp(500);
        });
        setTimeout(() => {
          history.push('/joblist');
        }, 1000);
      }
      else {
        $("#repostjobfailMessage").fadeTo(2000, 500).slideUp(500, function () {
          $("#repostjobfailMessage").slideUp(500);
        });
        setTimeout(() => {

        }, 1000);

      }
    });
  }

  function openModal() {
    setIsOpen(true);
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }
  function closeModal() {
    setIsOpen(false);
  }

  const getWageInfoCall = () => {
    //var state = $("#stateId").val();
    //var county = $("#countyId").val(); 
    var job_code = $("#jobCodeTitle").html();
    var soc_code = $("#socCodeVal").html();

    var state = 'OH';
    var countyId: any = $("#job_location").val();
    if (countyId == "") {
      var county = 'Crawford County';
    } else {
      var county = countListAr[countyId] + ' County';
    }
    county = county == "" ? 'Crawford County' : county;
    setCountyDisplayName(county)

    //alert(socCodeTitle);      
    // alert(job_code);
    const requestObject = {
      "stateCode": state,
      "county": county,
      //"job_code": jobCode, 
      "job_code": job_code,
      "soccode": soc_code,
      //"soccode": socCode,      

    }
    // console.log(JSON.stringify(objInputAvailableJobs));
    var accessTokenIn = sessionStorage.getItem("adminAccToken");
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': "Bearer "+accessTokenIn 
        //'Authorization': accessTokenIn 
      },
      body: JSON.stringify(requestObject)
    };

    services.getSurveyWageList(requestOptions).then((res) => {
      console.log(JSON.stringify(res))
      if (res) {
        setWageListObj(res);
        setDolWageLevel1('');
        setDolWageLevel2('');
        setDolWageLevel3('');
        setDolWageLevel4('');

        setDolWageHourlyLevel1('');
        setDolWageHourlyLevel2('');
        setDolWageHourlyLevel3('');
        setDolWageHourlyLevel4('');

        setsurveyWageLevel1('');
        setsurveyWageLevel2('');
        setsurveyWageLevel3('');
        setsurveyWageLevel4('');

        setsurveyWageHourlyLevel1('');
        setsurveyWageHourlyLevel2('');
        setsurveyWageHourlyLevel3('');
        setsurveyWageHourlyLevel4('');
        try {
          if (typeof (res.dolWage[0].level1) != "undefined" && res.dolWage[0].level1 != null) {
            // alert(res.dolWage[0].level1);
            setDolWageLevel1(res.dolWage[0].level1);
            setDolWageLevel2(res.dolWage[0].level2);
            setDolWageLevel3(res.dolWage[0].level3);
            setDolWageLevel4(res.dolWage[0].level4);
          }
        } catch (ex) {

        }


        try {
          if (typeof (res.dolWageHourly[0].level1) != "undefined" && res.dolWageHourly[0].level1 != null) {

            setDolWageHourlyLevel1(res.dolWageHourly[0].level1);
            setDolWageHourlyLevel2(res.dolWageHourly[0].level2);
            setDolWageHourlyLevel3(res.dolWageHourly[0].level3);
            setDolWageHourlyLevel4(res.dolWageHourly[0].level4);
          }
        } catch (ex) {

        }



        try {
          if (typeof (res.surveyWage[0].level1) != "undefined" && res.surveyWage[0].level1 != null) {
            setsurveyWageLevel1(res.surveyWage[0].level1);
            setsurveyWageLevel2(res.surveyWage[0].level2);
            setsurveyWageLevel3(res.surveyWage[0].level3);
            setsurveyWageLevel4(res.surveyWage[0].level4);
          }
        } catch (ex) {

        }



        try {
          if (typeof (res.surveyWageHourly[0].level1) != "undefined" && res.surveyWageHourly[0].level1 != null) {
            setsurveyWageHourlyLevel1(res.surveyWageHourly[0].level1);
            setsurveyWageHourlyLevel2(res.surveyWageHourly[0].level2);
            setsurveyWageHourlyLevel3(res.surveyWageHourly[0].level3);
            setsurveyWageHourlyLevel4(res.surveyWageHourly[0].level4);
          }
        } catch (ex) {

        }


      }

    });



  }

  function applylink() {
    const applycheck = $('input[name="companyportal_consent"]:checked').length;
    if (applycheck > 0) {
      $('#portallinkdiv').show();
    }
    else {
      $('#portal_link').val('');
      $('#portallinkdiv').hide();
    }
  }

  function getJobInfo(jobId) {
    services.adminViewJobProfile(jobId).then((res) => {
      if (res.data) {
        setJobInfo(res.data.jobPostVo);
        setJobDetails(res.data.jobPostVo);
        setCompanyInfo(res.data.companyVo);

        var jobinfoob = res.data.jobPostVo;
        //console.log(jobinfoob);
        setselectedcompanyname(jobinfoob.companyId);
        setTimeout(() => {
          $('#posted_date').val(jobinfoob.createdDate);
          //$('#job_status').val(jobinfoob.status);
          // $('#approval_status').val(jobinfoob.status);
          var jstatus = jobinfoob.status;
          /* if(jstatus == "Published"|| jstatus == "published"){
             $('#approval_status').val('published');
           }
           if(jstatus == "Pending"|| jstatus == "pending"){
             $('#approval_status').val('pending');
           }
           if(jstatus == "Expired"|| jstatus == "expired"){
             $('#approval_status').val('expired');
           }
           $('#approval_status option[value=' + jstatus + ']').attr('selected', 'selected');
     */
          $('#job_location').val(jobinfoob.countyId);
          $('#job_location option[value=' + jobinfoob.countyId + ']').attr('selected', 'selected');

          $('#job_type').val(jobinfoob.jobTypeId);
          $('#job_type option[value=' + jobinfoob.jobTypeId + ']').attr('selected', 'selected');

          $('#education').val(jobinfoob.educationId);
          $('#education option[value=' + jobinfoob.educationId + ']').attr('selected', 'selected');

          //$('#career_level').val(); 

          var careerstat = jobinfoob.career;
          if (careerstat == "Entry-Level") {
            $('#career_level').val('Entry-Level');
          }
          else if (careerstat == "Mid-Level") {
            $('#career_level').val('Mid-Level');
          }
          else if (careerstat == "Management/Supervisor") {
            $('#career_level').val('Management/Supervisor');
          }

          else if (careerstat == "Executive-Level") {
            $('#career_level').val('Executive-Level');
          }
          else {
            $('#career_level').val('');
          }


          //$('#career_level option[value=' + jobinfoob.career + ']').attr('selected', 'selected');

          $('#how_to_apply').val(jobinfoob.apply);
          $('#reference_code').val(jobinfoob.reference);
          var catarray = jobinfoob.jobCategoryRelId;
          for (var i = 0; i < catarray.length; i++) {
            $('#' + catarray[i]).prop('checked', true);
          }

          var applylinkval = jobinfoob.jobApplyUrl;

          if (applylinkval == '' || applylinkval == null) {
            $('input[name="companyportal_consent"]').prop("checked", false);
            $('#portallinkdiv').hide();
          }
          else {
            $('input[name="companyportal_consent"]').prop("checked", true);
            $('#portallinkdiv').show();
            $('#portal_link').val(applylinkval);
          }

          var newcatarray = catarray.filter(x => x !== null);
          console.log('******old array : ' + catarray);
          console.log('******new array : ' + newcatarray);

          if (newcatarray.length >= 3) {
            $('input[name="category_list"]').not(':checked').prop('disabled', true);
          } else {
            $('input[name="category_list"]').prop('disabled', false);
          }

          $("#job_title").val(res.data.jobPostVo.title);
        }, 1500)


        // validateCheck();
        setDisplayJobTitle(res.data.jobPostVo.title);
      }

    });
  };
  const changeCountyTrigger = () => {
    //alert('400');
    getWageInfoCall();
  }

  const getLocationCounty = () => {
    services.getLocationCounty().then((res) => {
      console.log("getLocationCounty data=" + JSON.stringify(res.data));
      setLocationCounty(res.data.content);

      var countyArr = res.data.content;
      var countListArTemp: any = {};
      //alert(JSON.stringify(countyArr))
      for (var j = 0; j < countyArr.length; j++) {
        var atval = countyArr[j]['jobLocationCountyId'];
        countListArTemp[atval] = countyArr[j].name;
        //alert(JSON.stringify(countListArTemp))
      }
      //alert(JSON.stringify(countLdirectoryistArTemp))
      setCountListAr(countListArTemp);


    });
  }

  useEffect(() => {
    $("#job_title").change(function () {
      var st: any = $("#job_title").val();
      setJobCodeTitleInput(st);
    });
    $('#portalLinkValidregex').hide();
    $(".se-dialog-tabs").hide();
    $('#portallinkdiv').hide();
    //alert(job_id+' - '+expstat);
    $("#categoryError").hide();
    validateCheck();
    $('#repostjobsuccessMessage').hide();
    $('#repostjobfailMessage').hide();
    $("#summaryValidMsg").hide();
    $("#experienceValidMsg").hide();
    $("#salaryValidMsg").hide();
    $("#statusValidMsg").hide();
    $("#jobtitleValidMsg").hide();
    $('#joblocationValidMsg').hide();
    $('#jobtypeValidMsg').hide();
    $('#educationValidMsg').hide();
    $('#careerLevelValidMsg').hide();
    $('#applyValidMsg').hide();
    $('#howtoapplyValidregex').hide();
    $('#categoryValidMsg').hide();
    $('#jobcodeValidMsg').hide();
    $('#soccodeValidMsg').hide();
    getLocationCounty();
    /*services.getLocationCounty().then((res) => {
      //console.log("getLocationCounty data=" + JSON.stringify(res.data));
      setLocationCounty(res.data.content);
    });*/
    services.getJobType().then((res) => {
      // console.log("setJobType data=" + JSON.stringify(res.data));
      //setJobType(res.data.content);
      var jobtype_unsort = res.data.content;
      var jobtypes_sorted = jobtype_unsort.sort((a, b) => b.jobTypeId - a.jobTypeId);
      jobtypes_sorted = jobtypes_sorted.filter(function (elem) {
        return elem.name !== 'Continuing Education';
      });
      array_move(jobtypes_sorted, 0, (jobtypes_sorted.length - 1));
      setJobType(jobtypes_sorted);
    });
    services.getEducation().then((res) => {
      console.log("getEducation data=" + JSON.stringify(res.data));
      setEducation(res.data.content);
    });
    services.getIndustryData().then((res) => {

      console.log("Industry data=" + JSON.stringify(res.data));

      setCategory(res.data.content);

    });

    getJobInfo(job_id);
  }, []);

  function array_move(arr, old_index, new_index) {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
  };
  return (
    <>
      {tabId == null ? '' : <Breadcrumb style={{ opacity: "0.8", paddingBottom: "15px", marginTop: "-15px", borderBottom: "1px solid #999 " }} >
        {items.map((item) =>
          item.href === hrefIn ? (
            <Breadcrumb.Item active>{item.name}</Breadcrumb.Item>
          ) : (
            <Breadcrumb.Item linkProps={{ to: item.href }} linkAs={Link}>
              {item.name}
            </Breadcrumb.Item>
          )
        )}
      </Breadcrumb>
      }


      <PageTitle breadcrumbs={[]}>{displayJobTitle}</PageTitle>

      <form onSubmit={handleSubmit(submitValue)} className="mt-5">
        <div className="container">
          <div className="row">



            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label"><strong>Job Posted On : </strong>{moment(jobInfo.createdDate).format("MM/DD/YYYY")}</label>
                </div>

              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label"><strong>Company Name : </strong>{companyInfo.companyName}</label>
                </div>

              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">

                <div className="d-flex flex-column ">
                  <label className=" required form-label">Status</label>
                  <small className="mb-3">Overall Approval Status</small>
                </div>

                <select id="approval_status" name="approval_status" className="form-select" aria-label="Select example">
                  <option value="published" selected>Published</option>
                  <option value="pending">Pending</option>
                </select>


                <div id="statusValidMsg" style={{ color: red }} className="error">Approval Status is required.</div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Title</label>

                </div>
                <input type="text" id="job_title" name="job_title" className="form-control" placeholder="" />
                <div id="jobtitleValidMsg" style={{ color: red }} className="error">Job Title is required.</div>
              </div>
            </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Standardized Job Code</label>

                </div>

                <AsyncSelect
                  cacheOptions
                  components={animatedComponentssoc}
                  getOptionLabel={(e: any) => e.title}
                  getOptionValue={(e) => e.socCode}
                  loadOptions={loadOptions}
                  onInputChange={(value) => setQuerysoc(value)}
                  onChange={handleChange}
                // onChange={(value) => setSocCode(value)}
                />

                <div id="jobcodeValidMsg" style={{ color: red }} className="error">Job Code is required.</div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Soc Code</label>
                  <span id="socCodeVal">{socCode}</span>
                </div>

                <div id="soccodeValidMsg" style={{ color: red }} className="error">Soc Code is required.</div>
              </div>
            </div>


            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job is Located in which county</label>

                </div>
                <select className="form-select" id="job_location" name="job_location" aria-label="Select example" onChange={changeCountyTrigger}>
                  <option value="" >Select Job Location</option>
                  {
                    locationCounty.map((data, index) => (
                      <option value={data.jobLocationCountyId} >{data.name}</option>
                    ))}
                </select>
                <div id="joblocationValidMsg" style={{ color: red }} className="error">Job Location is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Type</label>

                </div>
                <select className="form-select" id="job_type" name="job_type" aria-label="Select example" >
                  <option value="" >Select Job Type</option>
                  {
                    jobTypes.map((data, index) => (
                      <option
                        selected={data.jobTypeId == jobDetails.jobTypeId ? true : false}
                        value={data.jobTypeId} >{data.name}</option>
                    ))}
                </select>
                <div id="jobtypeValidMsg" style={{ color: red }} className="error">Job Type is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Education</label>

                </div>
                <select className="form-select" id="education" name="education" aria-label="Select example" >
                  <option value=''>Select Education</option>
                  {
                    educations.map((data, index) => (
                      <option
                        selected={data.educationId == jobDetails.educationId ? true : false}
                        value={data.educationId}>{data.name}</option>
                    ))}
                </select>
                <div id="educationValidMsg" style={{ color: red }} className="error">Education is required.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Career Level</label>

                </div>
                <select className="form-select" id="career_level" name="career_level" aria-label="Select example" >
                  <option value=''>Select</option>

                  <option value="Entry-Level">Entry-Level</option>
                  <option value="Mid-Level">Mid-Level</option>
                  <option value="Management/Supervisor">Management/Supervisor</option>
                  <option value="Executive-Level">Executive Level</option>


                  {/* <option selected={"Entry-Level" == jobDetails.career ? "selected" : ""} value="Entry-Level">Entry-Level</option>
                               <option selected={"Mid-Level" == jobDetails.career ? "selected" : ""}  value="Mid-Level">Mid-Level</option>
                               <option selected={"Management/Supervisor" == jobDetails.career ? "selected" : ""}  value="Management/Supervisor">Management/Supervisor</option>
                               <option selected={"Executive Level" == jobDetails.career ? "selected" : ""}  value="Executive Level">Executive Level</option> */}

                </select>
                <div id="careerLevelValidMsg" style={{ color: red }} className="error">Career Level is required.</div>
              </div>
            </div>

          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className=" form-label">Additional Instructions to Apply</label>
                  <small>Max 250 Characters</small>
                </div>
                <input type="text" id="how_to_apply" name="how_to_apply" className="form-control" placeholder="" maxLength={250} />
                <div id="applyValidMsg" style={{ color: red }} className="error">Additional instructions to apply is required.</div>
                <div id="howtoapplyValidregex" style={{ color: red }} className="error">Please enter valid website URL.</div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="form-label">Reference Code</label>
                  <small className="vhidden"> Reference Code </small>
                </div>
                <input type="text" id="reference_code" name="reference_code" className="form-control" placeholder="" />
              </div>
            </div>
          </div>

          <div className="col-lg-12 mb-4">
            <input className="form-check-input" type="checkbox" name="companyportal_consent" value="Y" id="companyportal_consent1" onClick={() => applylink()} />  <label className="form-check-label" htmlFor="defaultCheck1"> Check this box to receive applicants on your external website </label>
          </div>

          <div className="col-lg-12 mb-4" id="portallinkdiv">
            <div className="d-flex"><label htmlFor="firstName" className="form-label mr-2">Link to job portal:  </label> <small>Link Should start with http or https. (Ex: http://www.example.com)</small></div>
            <input type="text" className="form-control" name="portal_link" id="portal_link" placeholder="" />

            <div id="portalLinkValidregex" style={{ color: red }} className="error">Please enter valid link.</div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Summary</label>


                </div>
                {/*<h2>editor area</h2> */}
                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="summaryId"   
                            data={jobInfo.summary}                         
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setSummary(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSummaryDesc}
                  setContents={jobInfo.summary}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                <div id="summaryValidMsg" style={{ color: red }} className="error">Sunnary is required.</div>
                {/*  <textarea className="form-control textarea" placeholder="Summary" id="summary" name="summary" spellcheck="false" {...register("summaryinfo", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })}></textarea>
                        <ErrorMessage
                          errors={errors}
                          name="summaryinfo"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Experience / Certification Required</label>

                </div>
                {/*<h2>editor area</h2>*/}
                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="experienceId"     
                            data={jobInfo.experiance}                        
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setExperience(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */

                  <SunEditor
                    setOptions={{
                      height: "400",
                      //buttonList: [['font', 'align'], ['image']]

                      buttonList: [
                        ['undo', 'redo'],
                        ['font', 'fontSize', 'formatBlock'],
                        ['paragraphStyle', 'blockquote'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor', 'textStyle'],
                        ['removeFormat'],
                        '/', // Line break
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                        ['fullScreen', 'showBlocks', 'codeView'],
                        ['preview'],

                        /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                      ]
                      //buttonList: buttonList.complex
                      // plugins: [font] set plugins, all plugins are set by default
                      // Other option
                    }}
                    onChange={handleChangeExperienceDesc}
                    setContents={jobInfo.experiance}
                    //onImageUpload={handleImageUpload}
                    onImageUploadBefore={handleImageUploadBefore}
                  />}
                <div id="experienceValidMsg" style={{ color: red }} className="error">Experience is required.</div>
                {/* <textarea className="form-control textarea" placeholder="Experience / Certification" id="experience" name="experience" spellcheck="false" {...register("expCertification", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })}></textarea>
                         <ErrorMessage
                          errors={errors}
                          name="expCertification"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12"> Wage Data </div>


            <div className="col-lg-12">
              <div className="mb-10">
                <button type="button" onClick={openModal} className="reg-button mt-2 mb-5">WAGE DATA</button>
                <Modal
                  isOpen={modalIsOpen}
                  onAfterOpen={afterOpenModal}
                  onRequestClose={closeModal}
                  style={customStyles}
                  contentLabel="Example Modal"
                >
                  <div className="d-flex justify-content-between">
                    <h2 ref={(_subtitle) => (subtitle = _subtitle)}>WAGE DATA</h2>
                    <button onClick={closeModal} className="wage-close">close</button>
                  </div>
                  <div className="wd-modal-auto">

                  <table className="table wage-table">
                    <tr>
                      <td>
                        <b>Location: </b> OH, {countyDisplayName}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>Job Title: </b> {jobCodeTitleInput}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>Standardized Job Title: </b> <span id="jobCodeTitle">{jobCodeTitle}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <b>SOC CODE: </b> <span >{socCode}</span>
                      </td>
                    </tr>


                  </table>


                  <table className="table wage-data-tb pj-wd" >
                    <thead className="thead-light">
                      <tr >
                        <th scope="col" style={{paddingLeft:"15px"}}>SOURCE</th>
                        <th scope="col">Type</th>
                        <th scope="col">LEVEL-1</th>
                        <th scope="col">LEVEL-2</th>
                        <th scope="col">LEVEL-3</th>
                        <th scope="col">LEVEL-4</th>


                      </tr>
                    </thead>
                    <tbody>
                      <tr>

                        <th scope="row" style={{paddingLeft:"15px"}} rowSpan={2}>DOL Wage Data</th>
                        <td id="">Yearly</td>
                        <td id="dol_level1">{dolWageLevel1}</td>
                        <td id="dol_level2">{dolWageLevel2}</td>
                        <td id="dol_level3">{dolWageLevel3}</td>
                        <td id="dol_level4">{dolWageLevel4}</td>

                      </tr>

                      <tr>
                        <td id="">Hourly</td>
                        <td id="dol_level1_hourly">{dolWageHourlyLevel1}</td>
                        <td id="dol_level2_hourly">{dolWageHourlyLevel2}</td>
                        <td id="dol_level3_hourly">{dolWageHourlyLevel3}</td>
                        <td id="dol_level4_hourly">{dolWageHourlyLevel4}</td>

                      </tr>

                      <tr>
                        <th scope="row" style={{paddingLeft:"15px"}} rowSpan={2}>Local Survey Data</th>

                        <td id="">Yearly</td>
                        <td id="com_level1">{surveyWageLevel1}</td>
                        <td id="com_level2">{surveyWageLevel2}</td>
                        <td id="com_level3">{surveyWageLevel3}</td>
                        <td id="com_level4">{surveyWageLevel4}</td>

                      </tr>


                      <tr>
                        <td id="">Hourly</td>
                        <td id="com_level1_hourly">{surveyWageHourlyLevel1}</td>
                        <td id="com_level2_hourly">{surveyWageHourlyLevel2}</td>
                        <td id="com_level3_hourly">{surveyWageHourlyLevel3}</td>
                        <td id="com_level4_hourly">{surveyWageHourlyLevel4}</td>

                      </tr>

                    </tbody>
                  </table>

                  </div>
                </Modal>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="mb-10">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Salary Benifits</label>


                </div>
                {/*<h2>editor area</h2>*/}

                <SunEditor
                  setOptions={{
                    height: "400",
                    //buttonList: [['font', 'align'], ['image']]

                    buttonList: [
                      ['undo', 'redo'],
                      ['font', 'fontSize', 'formatBlock'],
                      ['paragraphStyle', 'blockquote'],
                      ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                      ['fontColor', 'hiliteColor', 'textStyle'],
                      ['removeFormat'],
                      '/', // Line break
                      ['outdent', 'indent'],
                      ['align', 'horizontalRule', 'list', 'lineHeight'],
                      ['table', 'link', 'image' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.                    
                      ['fullScreen', 'showBlocks', 'codeView'],
                      ['preview'],

                      /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                    ]
                    //buttonList: buttonList.complex
                    // plugins: [font] set plugins, all plugins are set by default
                    // Other option
                  }}
                  onChange={handleChangeSalaryDesc}
                  setContents={jobInfo.salary}
                  //onImageUpload={handleImageUpload}
                  onImageUploadBefore={handleImageUploadBefore}
                />
                {/* <CKEditor
                            editor={ ClassicEditor }
                            config={{
                              removePlugins: ["EasyImage","ImageUpload","MediaEmbed"]
                            }}
                            id="salaryId" 
                            data={jobInfo.salary}                            
                            onReady={ editor => {
                                // You can store the "editor" and use when it is needed.
                                console.log( 'Editor is ready to use!', editor );
                                //editor.setData(profileDescription);
                                //editor.setData(profileDescription);
                                
                            } }
                            onChange={ ( event, editor ) => {
                                const data = editor.getData();
                                setSalary(data);
                                console.log( { event, editor, data } );
                            } }
                            onBlur={ ( event, editor ) => {
                                console.log( 'Blur.', editor );
                            } }
                            onFocus={ ( event, editor ) => {
                                console.log( 'Focus.', editor );
                            } }
                        /> */}
                <div id="salaryValidMsg" style={{ color: red }} className="error">This field is required.</div>
                {/*     <textarea className="form-control textarea" placeholder="Salary Benifits" id="sal_benefits" name="sal_benefits" spellcheck="false" {...register("salaryBenefits", {
                          required: "This field is required",
                          maxLength: { value: 2000, message: 'Should not allow more than 2000 characters' }
                        })} ></textarea>
                        <ErrorMessage
                          errors={errors}
                          name="salaryBenefits"
                          className="invalid-feedback"
                          render={({ messages }) => {
                            console.log("messages", messages);
                            return messages
                              ? Object.entries(messages).map(([type, message]) => (
                                <p key={type} className="error">{message}</p>
                              ))
                              : null;
                          }}

                        /> */}
              </div>
            </div>

            <div className="col-lg-12 mb-10">
              <div className="mb-5">
                <div className="d-flex flex-column ">
                  <label className="required form-label">Job Industry</label>
                  <small className="mb-3">Max 3 Categories</small>
                </div>
              </div>
              <div className="row">

                {

                  categories.map((category, index) => (
                    <ul className="col-md-6 mb-4">
                      <li className="form-check form-check-custom form-check-solid"><input className="form-check-input" type="checkbox" value={category.catId} name="category_list" id={category.catId} onClick={() => validateCheck()} />  <label className="form-check-label" htmlFor="defaultCheck1"> {category.name} </label></li>
                    </ul>
                  ))

                }

                <div id="categoryValidMsg" style={{ color: red }} className="error">Please Check at least 1 category.</div>
                {/* {errors.category && errors.category.type === "required" && <div style={{color:red}} className="error">Please check atleast One category</div>} */}

              </div>
            </div>

            <button type="submit" className="btn btn-primary mt-10" style={{ maxWidth: "200px" }}>Post Job </button>


          </div>
          <div id="repostjobsuccessMessage" className="alert alert-success" role="alert">Job Posted Successfully</div>
          <div id="repostjobfailMessage" className="alert alert-danger" role="alert">Please try again</div>
        </div>

      </form>

    </>
  )
}
export { RepostJob }